import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyCountry',
})
export class CurrencyCountryPipe implements PipeTransform {
  /**
   * returns the country code of the currency.
   * @param value currency currency
   * @author Martin Batun Tec.
   */
  transform(value: string): any {
    switch (value) {
      case 'EUR':
        return 'eu';
      case 'GBP':
        return 'gb';
      case 'USD':
        return 'us';
      case 'AED':
        return 'ae';
      case 'AUD':
        return 'au';
      case 'BGN':
        return 'bg';
      case 'BHD':
        return 'bh';
      case 'BWP':
        return 'bw';
      case 'CAD':
        return 'ca';
      case 'CHF':
        return 'ch';
      case 'CZK':
        return 'cz';
      case 'DKK':
        return 'dk';
      case 'HKD':
        return 'hk';
      case 'HUF':
        return 'hu';
      case 'ILS':
        return 'il';
      case 'JPY':
        return 'jp';
      case 'KWD':
        return 'kw';
      case 'MXN':
        return 'mx';
      case 'NOK':
        return 'no';
      case 'NZD':
        return 'nz';
      case 'OMR':
        return 'om';
      case 'PLN':
        return 'pl';
      case 'QAR':
        return 'qa';
      case 'RON':
        return 'ro';
      case 'SAR':
        return 'sa';
      case 'SEK':
        return 'se';
      case 'SGD':
        return 'sg';
      case 'TND':
        return 'tn';
      case 'UGX':
        return 'ug';
      case 'ZAR':
        return 'za';
      case 'BRL':
        return 'br';
      case 'COP':
        return 'co';
      case 'ARS':
        return 'ar';
      case 'CLP':
        return 'cl';
      case 'PEN':
        return 'pe';
      case 'EGP':
        return 'eg';
      case 'GTQ':
        return 'gt';
      case 'HNL':
        return 'hn';
      case 'IDR':
        return 'id';
      case 'INR':
        return 'in';
      case 'ISK':
        return 'is';
      case 'KES':
        return 'ke';
      case 'MAD':
        return 'ma';
      case 'MYR':
        return 'my';
      case 'NPR':
        return 'np';
      case 'PHP':
        return 'ph';
      case 'PKR':
        return 'pk';
      case 'THB':
        return 'th';
      case 'TRY':
        return 'tr';
      case 'UYU':
        return 'uy';
      case 'VND':
        return 'vn';
    }
  }
}
